<template>
  <div class="amap-container" :id="penID" ref="ampcontent"></div>
</template>
<script>

export default {
  props: {
    penID: {
      type: String,
      default: "",
    },
    location: {
      type: Array,
      default: () => [116.397428, 39.90923],
    },
    zoom: {
      type: Number,
      default: 12,
    },
    city: {
      type: String,
      default: "",
    },
  },
  watch: {
    location(val) {
      if (!this.map || !val) return;
      this.map.setCenter(val);
    },
    zoom(val) {
      if (!val || !this.map) return;
      this.map.setZoom(val);
    },
    city(val) {
      if (!this.map) return;
      this.map.setCity(val);
    },
  },
  mounted() {
    window.amapOnLoad = () => {
      
      if (this.map){
        this.$message.warning('舞台上只能存在多个地图组件，可能导致无法正常渲染')
        return;
      }
      const map = new window.AMap.Map(this.$refs.ampcontent, {
        zoom: this.zoom, //级别
        center: this.location, //中心点坐标
        viewMode: "3D", //使用3D视图
      });
      this.map = map;
      if(this.city){
        this.map.setCity(this.city);
      }
    };

    if (!window.AMap) {
      const url =
        "https://webapi.amap.com/maps?v=1.4.15&key=b74c3effa22cefd8e5147e610edacdda&callback=amapOnLoad";
      const jsapi = document.createElement("script");
      jsapi.charset = "utf-8";
      jsapi.src = url;
      document.head.appendChild(jsapi);
    }

    if (window.AMap && !this.map) {
      window.amapOnLoad();
    }
  },
};
</script>
<style lang="scss" scoped>
.amap-container {
  height: 100%;
  width: 100%;
}
</style>